// extracted by mini-css-extract-plugin
export default {"root":"root--_wP4M"};